// Port of api/fuel/app/classes/filter/search/games/sorts/post/rating/group/divisive.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import { sorted, sortReverse } from 'offline/filter/core/search/unit'

export default {
	name: 'post.sort.rating.group.divisive',
	post: true,
	sorts: function() {
		return ['rating.divisive']
	},
	modifies: function() {
		return 'index'
	},
	require: function(config, filter) {
		return config.ownerType !== F.OWNER_USER && sorted('rating.divisive', filter) > 0
	},
	run: function(config, filter, data, results) {
		if (!results.games || !results.games.length) return results
		var rows = DB.query('SELECT game_id, rating_value FROM rating WHERE game_id IN(' + Util.in(results.games) + ') AND user_id IN(' + Util.in(data.users) + ')')
		var byGame = {}
		for (var i = 0; i < rows.length; i++) {
			if (!byGame[rows[i].game_id]) byGame[rows[i].game_id] = []
			byGame[rows[i].game_id].push(parseFloat(rows[i].rating_value))
		}
		var diffs = {}
		var gk = Object.keys(byGame)
		for (var g = 0; g < gk.length; g++) {
			var ratings = byGame[gk[g]]
			if (ratings.length < 2) { diffs[gk[g]] = 0; continue }
			var s = ratings.slice().sort(function(a,b){return a-b})
			var mid = Math.floor(s.length/2)
			var median = s.length%2 ? s[mid] : (s[mid-1]+s[mid])/2
			var td = 0
			for (var r = 0; r < ratings.length; r++) td += Math.abs(ratings[r] - median)
			diffs[gk[g]] = Math.round((td / ratings.length) * 100) / 100
		}
		var reverse = sortReverse('rating.divisive', filter)
		results.games.sort(function(a, b) {
			return reverse ? (diffs[b]||0) - (diffs[a]||0) : (diffs[a]||0) - (diffs[b]||0)
		})
		var gameOrder = {}
		for (var j = 0; j < results.games.length; j++) gameOrder[results.games[j]] = j
		results.index.sort(function(a, b) {
			var ga = results.mapIndex ? results.mapIndex[a] : a
			var gb = results.mapIndex ? results.mapIndex[b] : b
			return (gameOrder[ga]||0) - (gameOrder[gb]||0)
		})
		return results
	}
}
